import React, { useMemo, useState } from 'react'

import { Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'

import { Personal } from '@/components/Personal'
import { SearchInput } from '@/pages/MesperyIM/components/SearchInput'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import DelSrc from '@img/components/del2.png'

import useSessionListUsers from '../hooks/useSessionListUsers'
import styles from '../message.module.less'

interface IProps {
  change: (step: string) => void
  userIds: string[]
  setUserIds: React.Dispatch<React.SetStateAction<string[]>>
}

export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

export const CreateGroupStep1: React.FC<IProps> = (props) => {
  const { change, userIds, setUserIds } = props
  const { setCreateCroup } = useMessageAtom()
  const [searchVal, setSearchVal] = useState('')
  const { sessionListUsers } = useSessionListUsers()

  const userList = useMemo(() => {
    const sortData = sessionListUsers?.sort(
      (a, b) => a.session_name?.localeCompare(b.session_name || '') || 0
    )

    letters.forEach((preFix) => {
      const index = sortData?.findIndex(
        (data) => data.session_name?.toLocaleUpperCase()[0] === preFix
      )
      if (index && index !== -1 && sortData) {
        sortData[index].preFix = preFix
      }
    })

    return sortData
  }, [sessionListUsers])

  const handleSelect = (id: string) => {
    if (userIds.includes(id)) {
      setUserIds(userIds.filter((item) => item !== id))
    } else {
      setUserIds([...userIds, id])
    }
  }

  return (
    <>
      <div className="step1-left">
        <div className="search-box">
          <SearchInput
            value={searchVal}
            onChange={(e) => {
              setSearchVal(e.target.value)
            }}
          />
        </div>
        <div className={`${styles.ContactList} scroll-box`}>
          <ul>
            {userList?.map((item) => {
              return (
                <div
                  key={item.session_id}
                  className={`${
                    item.session_name?.indexOf(searchVal) !== -1
                      ? ''
                      : 'g-hidden'
                  }`}
                  onClick={() => {
                    handleSelect(item.session_id || '')
                  }}
                >
                  {item.preFix && <div className="letter">{item.preFix}</div>}
                  <li>
                    <Checkbox
                      className="ml4 mr10 c-radio"
                      value={item.session_id}
                      checked={userIds.includes(item.session_id || '')}
                    />
                    <Personal
                      nickname={item.session_name}
                      userData={{ id: item.session_id }}
                    />
                  </li>
                </div>
              )
            })}
          </ul>
        </div>
      </div>
      <div className="step1-right">
        <div className={`${styles.ContactList} scroll-box`}>
          <ul>
            {userList?.map((item) => {
              return userIds.includes(item.session_id || '') ? (
                <li key={item.session_id}>
                  <Personal
                    nickname={item.session_name}
                    userData={{ id: item.session_id }}
                  />
                  <a>
                    <img
                      src={DelSrc}
                      width={18}
                      onClick={() => {
                        setUserIds(
                          userIds.filter((userId) => userId !== item.session_id)
                        )
                      }}
                    />
                  </a>
                </li>
              ) : null
            })}
          </ul>
        </div>
        {/* 按钮 */}
        <div className="footer">
          <button className="g-btn mr20" onClick={() => setCreateCroup(false)}>
            Cancel
          </button>
          <button
            className="g-btn g-btn-primary mr20"
            onClick={() => change('step2')}
          >
            Next
          </button>
        </div>
      </div>
    </>
  )
}
